import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "is-size-5 has-text-weight-bold section-label" }
const _hoisted_2 = {
  key: 0,
  class: "is-italic"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-5 has-text-weight-bold section-label" }, "Message", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "stripe-mount" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "error has-text-danger"
}
const _hoisted_7 = ["action"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createBlock(_component_NrModal, {
    show: $props.show,
    class: "request-payments-form",
    "has-secondary-button": true,
    title: "Make payment",
    "primary-button-text": "Submit payment",
    "secondary-button-text": "Cancel",
    "disable-buttons": $data.disableSubmit,
    onOnPrimaryClick: $options.submitPayment,
    onOnSecondaryClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveModal(''))),
    onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveModal('')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, " Amount: " + _toDisplayString($options.invoiceAmount), 1),
      ($options.invoiceFeesText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($options.invoiceFeesText), 1))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createElementVNode("div", {
        class: "content",
        innerHTML: $props.invoice.message
      }, null, 8, _hoisted_4),
      (_ctx.account && _ctx.account.stripe_activated)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitPayment && $options.submitPayment(...args)), ["prevent"]))
          }, [
            _hoisted_5,
            ($data.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($data.error), 1))
              : _createCommentVNode("", true)
          ], 32))
        : _createCommentVNode("", true),
      (
        _ctx.account &&
        (_ctx.account.cybersource_activated || _ctx.account.cybersource_test_activated)
      )
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            ref: "cybersourceForm",
            method: "post",
            action: $data.cybersource.form_action
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($data.cybersource.params || {}), ([field, value]) => {
              return (_openBlock(), _createBlock(_component_NrFormInput, {
                key: field,
                type: "hidden",
                name: field,
                modelValue: value
              }, null, 8, ["name", "modelValue"]))
            }), 128))
          ], 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show", "disable-buttons", "onOnPrimaryClick"]))
}